import { Button, Stack } from "@mantine/core"
import { useForm } from "@mantine/form"
import { MasterTradeParams } from "app/models/master-trade-params"
import { editReferencesDetails } from "app/state/ducks/master-trades/thunks"
import BlackTextInput from "app/views/components/inputs/BlackTextInput"
import { ErrorNotification, SuccessNotification } from "app/views/components/notifications/notification"
import { useState } from "react"
import { useDispatch } from "react-redux"

type Params = {
    trade?: MasterTradeParams
    closeModal: () => void
    onHandleSubmit?: any
}
export default function EditReferencesForm({
    trade,
    closeModal,
    onHandleSubmit,
}: Params) {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)

    const form = useForm({
        initialValues: {
            trader: trade?.trader ?? '',
            closer: trade?.closer ?? '',
            pm: trade?.pm ?? '',
            desk: trade?.desk ?? "",
            counterpartyCloser: trade?.counterpartyCloser ?? "",
        }
    })

    async function onSubmit(referenceDetails: any) {
        try {
            setIsLoading(true)
            const response: any = await dispatch(editReferencesDetails(referenceDetails, trade))
            if (response.success) {
                SuccessNotification({
                    title: 'Successful Reference Details Saved',
                    message: 'You edited an reference details for open Trade',
                })
            } else {
                ErrorNotification({
                    title: 'Reference details save failed',
                    message: response.payload ?? 'Check data and try again',
                })
            }
            return undefined
        } catch {
            ErrorNotification({
                title: 'Reference Details save failed',
                message: 'Check data and try again',
            })
        } finally {
            setIsLoading(false)
        }
    }

    async function submitForm(event: any) {
        event.preventDefault()
        if (!form.validate().hasErrors) {
            const trade = await onSubmit(form.getTransformedValues())
            onHandleSubmit(trade ?? form.values)
        } else {
            ErrorNotification({
                title: 'Form Validation Error',
                message: 'Please fill in required fields',
            });
        }
    }

    return (
        <form onSubmit={submitForm} className="stepper-form">

            <Stack spacing="12px !important">
                <BlackTextInput label="Trader" {...form.getInputProps("trader")} />

                <div className="edit-trade-input-field-tuple">
                    <BlackTextInput label="Closer" {...form.getInputProps("closer")} />
                    <BlackTextInput label="PM" {...form.getInputProps("pm")} />
                </div>

                <div className="edit-trade-input-field-tuple">
                    <BlackTextInput label="Counterparty  Closer" {...form.getInputProps("counterpartyCloser")} />
                    <BlackTextInput label="Desk" {...form.getInputProps("desk")} />
                </div>

                <div className="action-buttons-block">
                    <Button className="cancel-button" onClick={() => closeModal()}>Cancel</Button>

                    <Button
                        type="submit"
                        loading={isLoading}
                        disabled={!form.isValid()}
                        className="delete-button stratch-delete-button"
                    >
                        Save
                    </Button>
                </div>
            </Stack>
        </form>

    )
}
